module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0087.jpg?v=ce50b892";